export enum FeatureGuide {
  PreviousNextNavigation = 'previousNext.1',
  CalendarSelectionHint = 'calendarSelection.1',
  CalendarDeselectionHint = 'calendarSelection.2',
  CalendarSelectionExplanation = 'calendarSelection.3'
}
